import { Button, Divider, Skeleton, Tabs } from 'antd';
import API from 'API';
import React, { useEffect, useMemo, useState } from 'react'
import InvitationsTable from 'components/InvitationsTable';

export default function Invitations() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [places, setPlaces] = useState([]);
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [updating, setUpdating] = useState(false);

    useEffect(() => {
        API.get("/update-invitation/")
            .then(res => {
                setPlaces(res.data);
                if (res.data.length > 0) {
                    setSelectedPlace(res.data[0]);
                }
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
            })
    }, [])

    const placeTabs = useMemo(() => places.map(item => ({
        key: item.id.toString(), label: item.tab,
    })), [places])

    return loading ? <Skeleton active /> : <>
        <div style={{ color: "red" }}>
            {error}
        </div>
        <Button type='primary' loading={updating} onClick={() => {
            setUpdating(true);
            setError(null);
            API.post("/update-invitation/")
                .then(res => {
                    setPlaces(res.data);
                    if (res.data.length > 0) {
                        setSelectedPlace(res.data[0]);
                    }
                })
                .catch(error => {
                    console.log(error);
                    setError(error.response?.data?.error);
                })
                .finally(() => {
                    setUpdating(false);
                })
        }}>
            Update
        </Button>
        <Divider />
        <Tabs items={placeTabs} activeKey={selectedPlace?.id.toString()} onChange={
            key => setSelectedPlace(places.find(item => item.id === +key))
        } />
        {selectedPlace && <InvitationsTable 
            invitations={selectedPlace.invitations}
            tab={selectedPlace.tab}
            setInvitations={(invitations) => {
                selectedPlace.invitations = invitations;
                const newSelectedPlace = {...selectedPlace};
                setSelectedPlace(newSelectedPlace);
                setPlaces(places.map(item => item.id === selectedPlace.id ? newSelectedPlace : item));
            }}
        />}
    </>
}
